(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis"] && !Shopify.designMode) return;
  try {
    

(() => {

  const initialise = (root) => {

    if (
      !root ||
      root.dataset.ready === 'true'
    ) return;


    const viewport =
      root.querySelector(
        '.osif-reviews__viewport'
      );


    const track =
      root.querySelector(
        '.osif-reviews__track'
      );


    const prev =
      root.querySelector(
        '.osif-reviews__arrow--prev'
      );


    const next =
      root.querySelector(
        '.osif-reviews__arrow--next'
      );


    const dots =
      root.querySelector(
        '.osif-reviews__dots'
      );


    if (
      !viewport ||
      !track
    ) return;


    const originals =
      [
        ...track.querySelectorAll(
          '.osif-review'
        )
      ];


    const count =
      originals.length;


    if (!count) return;


    root.dataset.ready =
      'true';


    let logicalIndex = 0;

    let timer = null;

    let scrollTimer = null;

    let resizeTimer = null;

    let isJumping = false;



    /*
    ====================================
    CREATE CLONES FOR TRUE INFINITE LOOP
    ====================================
    */


    if (
      root.dataset.loop === 'true' &&
      count > 1
    ) {


      const before =
        originals.map(
          card => {

            const clone =
              card.cloneNode(true);

            clone.removeAttribute(
              'id'
            );

            clone.removeAttribute(
              'data-shopify-editor-block'
            );

            clone.removeAttribute(
              'data-block-id'
            );

            clone.setAttribute(
              'aria-hidden',
              'true'
            );

            clone.dataset.clone =
              'true';

            return clone;

          }
        );


      const after =
        originals.map(
          card => {

            const clone =
              card.cloneNode(true);

            clone.removeAttribute(
              'id'
            );

            clone.removeAttribute(
              'data-shopify-editor-block'
            );

            clone.removeAttribute(
              'data-block-id'
            );

            clone.setAttribute(
              'aria-hidden',
              'true'
            );

            clone.dataset.clone =
              'true';

            return clone;

          }
        );


      before
        .reverse()
        .forEach(
          card => {

            track.insertBefore(
              card,
              track.firstChild
            );

          }
        );


      after.forEach(
        card => {

          track.appendChild(
            card
          );

        }
      );

    }



    const allCards =
      [
        ...track.querySelectorAll(
          '.osif-review'
        )
      ];



    /*
    ====================================
    DOTS
    ====================================
    */


    if (dots) {

      dots.innerHTML = '';


      originals.forEach(
        (card, i) => {

          const dot =
            document.createElement(
              'button'
            );


          dot.type =
            'button';


          dot.className =
            'osif-reviews__dot';


          dot.setAttribute(
            'aria-label',
            `Go to review ${i + 1}`
          );


          dot.addEventListener(
            'click',
            () => {

              goToLogical(i);

              restartAutoplay();

            }
          );


          dots.appendChild(
            dot
          );

        }
      );

    }



    const dotItems =
      dots
        ? [...dots.children]
        : [];



    /*
    ====================================
    HELPERS
    ====================================
    */


    const updateDots = () => {

      dotItems.forEach(
        (dot, i) => {

          dot.classList.toggle(
            'is-active',
            i === logicalIndex
          );

        }
      );

    };



    const getMiddleCard =
      logical => {


        if (
          root.dataset.loop === 'true' &&
          count > 1
        ) {

          return allCards[
            count + logical
          ];

        }


        return originals[
          logical
        ];

      };



    const instantScroll =
      left => {


        isJumping = true;


        const oldBehavior =
          viewport.style.scrollBehavior;


        const oldSnap =
          viewport.style.scrollSnapType;


        viewport.style.scrollBehavior =
          'auto';


        viewport.style.scrollSnapType =
          'none';


        viewport.scrollLeft =
          left;


        viewport.offsetHeight;


        requestAnimationFrame(
          () => {

            viewport.style.scrollBehavior =
              oldBehavior;


            viewport.style.scrollSnapType =
              oldSnap;


            requestAnimationFrame(
              () => {

                isJumping =
                  false;

              }
            );

          }
        );

      };



    /*
    ====================================
    GO TO REAL REVIEW
    ====================================
    */


    const goToLogical =
      logical => {


        if (!count) return;


        logical =
          (
            (
              logical % count
            )
            +
            count
          )
          %
          count;


        logicalIndex =
          logical;


        const target =
          getMiddleCard(
            logical
          );


        if (!target) return;


        viewport.scrollTo({

          left:
            target.offsetLeft,

          behavior:
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches
              ? 'auto'
              : 'smooth'

        });


        updateDots();

      };



    /*
    ====================================
    FIND CURRENT CARD
    ====================================
    */


    const findClosestCardIndex =
      () => {


        const left =
          viewport.scrollLeft;


        let closestIndex =
          0;


        let closestDistance =
          Infinity;


        allCards.forEach(
          (card, i) => {


            const distance =
              Math.abs(
                card.offsetLeft
                -
                left
              );


            if (
              distance <
              closestDistance
            ) {

              closestDistance =
                distance;


              closestIndex =
                i;

            }

          }
        );


        return closestIndex;

      };



    /*
    ====================================
    CORRECT INFINITE POSITION
    ====================================
    */


    const correctInfinitePosition =
      () => {


        if (isJumping) return;


        const closestIndex =
          findClosestCardIndex();


        if (
          root.dataset.loop === 'true' &&
          count > 1
        ) {


          const realIndex =
            (
              (
                closestIndex
                -
                count
              )
              %
              count
              +
              count
            )
            %
            count;


          logicalIndex =
            realIndex;


          updateDots();


          /*
          We are inside left or right clones:
          silently teleport to equivalent
          middle/original card.
          */


          if (
            closestIndex < count ||
            closestIndex >= count * 2
          ) {


            const middle =
              allCards[
                count + realIndex
              ];


            if (middle) {

              instantScroll(
                middle.offsetLeft
              );

            }

          }


        } else {


          logicalIndex =
            Math.max(
              0,
              Math.min(
                closestIndex,
                count - 1
              )
            );


          updateDots();


          if (prev) {

            prev.disabled =
              logicalIndex === 0;

          }


          if (next) {

            next.disabled =
              logicalIndex ===
              count - 1;

          }

        }

      };



    /*
    ====================================
    SCROLL / MOUSE / MOBILE SWIPE
    ====================================
    */


    viewport.addEventListener(
      'scroll',
      () => {


        if (isJumping) return;


        clearTimeout(
          scrollTimer
        );


        scrollTimer =
          setTimeout(
            () => {

              correctInfinitePosition();

            },
            100
          );

      },
      {
        passive: true
      }
    );



    /*
    ====================================
    ARROWS
    ====================================
    */


    if (prev) {


      if (
        root.dataset.loop === 'true'
      ) {

        prev.disabled =
          false;

      }


      prev.addEventListener(
        'click',
        () => {

          goToLogical(
            logicalIndex - 1
          );

          restartAutoplay();

        }
      );

    }



    if (next) {


      if (
        root.dataset.loop === 'true'
      ) {

        next.disabled =
          false;

      }


      next.addEventListener(
        'click',
        () => {

          goToLogical(
            logicalIndex + 1
          );

          restartAutoplay();

        }
      );

    }



    /*
    ====================================
    AUTOPLAY
    ====================================
    */


    const stopAutoplay =
      () => {


        if (timer) {

          clearInterval(
            timer
          );

          timer =
            null;

        }

      };



    const startAutoplay =
      () => {


        stopAutoplay();


        if (
          root.dataset.autoplay !==
            'true'
          ||
          count <= 1
          ||
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
        ) {

          return;

        }


        const speed =
          Number(
            root.dataset.speed
          )
          ||
          5000;


        timer =
          setInterval(
            () => {

              goToLogical(
                logicalIndex + 1
              );

            },
            speed
          );

      };



    const restartAutoplay =
      () => {

        stopAutoplay();

        startAutoplay();

      };



    /*
    ====================================
    AUTOPLAY PAUSE
    ====================================
    */


    root.addEventListener(
      'mouseenter',
      stopAutoplay
    );


    root.addEventListener(
      'mouseleave',
      startAutoplay
    );


    root.addEventListener(
      'focusin',
      stopAutoplay
    );


    root.addEventListener(
      'focusout',
      startAutoplay
    );



    viewport.addEventListener(
      'pointerdown',
      stopAutoplay,
      {
        passive: true
      }
    );



    viewport.addEventListener(
      'pointerup',
      () => {

        setTimeout(
          startAutoplay,
          900
        );

      },
      {
        passive: true
      }
    );



    viewport.addEventListener(
      'pointercancel',
      () => {

        setTimeout(
          startAutoplay,
          900
        );

      },
      {
        passive: true
      }
    );



    /*
    ====================================
    INITIAL POSITION
    ====================================
    */


    const setInitialPosition =
      () => {


        logicalIndex =
          0;


        updateDots();


        requestAnimationFrame(
          () => {


            requestAnimationFrame(
              () => {


                const target =
                  getMiddleCard(0);


                if (target) {

                  instantScroll(
                    target.offsetLeft
                  );

                }


                startAutoplay();

              }
            );

          }
        );

      };


    setInitialPosition();



    /*
    ====================================
    RESIZE
    ====================================
    */


    window.addEventListener(
      'resize',
      () => {


        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(
            () => {


              const target =
                getMiddleCard(
                  logicalIndex
                );


              if (target) {

                instantScroll(
                  target.offsetLeft
                );

              }

            },
            180
          );

      }
    );

  };



  document
    .querySelectorAll(
      '.osif-reviews'
    )
    .forEach(
      initialise
    );



  document.addEventListener(
    'shopify:section:load',
    event => {


      const section =
        event.target.querySelector(
          '.osif-reviews'
        );


      initialise(
        section
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colleec"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zugkrone-collection')) {
  customElements.define('zugkrone-collection', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      if (this.dataset.bestDefault === 'true' && this.dataset.pageType === 'collection' && this.dataset.editor !== 'true') {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('sort_by') && this.dataset.currentSort !== 'best-selling') {
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.delete('page');
          window.location.replace(url.toString());
          return;
        }
      }
      const dialog = this.querySelector('.bgc__dialog');
      const form = this.querySelector('.bgc__filter-form');
      const sidebar = this.querySelector('.bgc__sidebar');
      if (!dialog || !form || !sidebar) return;
      this.setAttribute('data-ready', '');
      const opener = this.querySelector('.bgc__filter-open');
      opener.addEventListener('click', () => {
        dialog.querySelector('.bgc__dialog-body').append(form);
        dialog.showModal();
      }, {signal});
      dialog.addEventListener('close', () => { sidebar.append(form); opener.focus(); }, {signal});
      this.querySelector('.bgc__filter-close').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => { if(event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right) dialog.close(); } }, {signal});
      this._media = matchMedia('(min-width: 750px)');
      this._media.addEventListener('change', e => { if(e.matches && dialog.open) dialog.close(); }, {signal});
      this.querySelector('.bgc__sort select').addEventListener('change', () => form.requestSubmit(), {signal});
      form.addEventListener('submit', event => {
        const nums = [...form.querySelectorAll('input[type="number"]')];
        if(nums.length === 2 && nums.every(n => n.value !== '') && Number(nums[0].value) > Number(nums[1].value)) {
          event.preventDefault();
          const previous = nums[0].value; nums[0].value = nums[1].value; nums[1].value = previous;
          form.requestSubmit();
        }
      }, {signal});
      this.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        const rail = this.querySelector('.bgc__rail');
        rail.scrollBy({left: Number(button.dataset.railStep) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.querySelectorAll('.bgc__image-toggle').forEach(button => button.addEventListener('click', () => {
        const media = button.closest('.bgc__media');
        const second = media.toggleAttribute('data-second');
        button.setAttribute('aria-pressed', String(second));
      }, {signal}));
    }
    disconnectedCallback() { this._controller?.abort(); this._controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('infos-defilantes')) {
    customElements.define('infos-defilantes', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
